module.exports = __webpack_public_path__ + "img/接单中.70f08b22.png";